<template>
    <div class="data-wrapper-core email-connections-wrapper">
        <template v-if="!hideHeader">
            <h3>Email Connections</h3>
            <v-divider></v-divider>
        </template>
        <v-text-field class="email-connections-search-field" prepend-inner-icon="mdi-magnify" variant="outlined"
            density="compact" label="Suche" hide-details single-line rounded="lg" v-model="searchQuery"></v-text-field>
        <v-expansion-panels>
            <v-expansion-panel rounded="lg" v-for="emailConnection in emailConnections" :key="emailConnection._id">
                <v-expansion-panel-title class="email-connections-panel-title">
                    <h4>{{ emailConnection.name }}</h4>
                </v-expansion-panel-title>
                <v-expansion-panel-text class="email-connections-panel-text">
                    <v-list density="compact">
                        <h4>Type:</h4>
                        <v-list-item>{{ emailConnection.type || "--" }}</v-list-item>
                        <h4>Ist Standard:</h4>
                        <v-list-item>{{ emailConnection.isStandard }}</v-list-item>
                        <div class="email-connections-sub-section">
                            <h4>Standard Sender:</h4>
                            <v-divider></v-divider>
                            <h4>Name:</h4>
                            <v-list-item>{{ emailConnection.standardSender.name || "--" }}</v-list-item>
                            <h4>Email:</h4>
                            <v-list-item>{{ emailConnection.standardSender.email || "--" }}</v-list-item>
                            <h4>id:</h4>
                            <v-list-item>{{ emailConnection.standardSender.id || "--" }}</v-list-item>
                        </div>
                        <h4>API-Key:</h4>
                        <v-list-item>{{ emailConnection.apiKey || "--" }}</v-list-item>
                        <h4>Erstellt am:</h4>
                        <v-list-item>{{ emailConnection.createdAt || "--" }}</v-list-item>
                        <h4>__v:</h4>
                        <v-list-item>{{ emailConnection.__v }}</v-list-item>
                        <h4>_id:</h4>
                        <v-list-item>{{ emailConnection._id }}</v-list-item>
                    </v-list>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        hideHeader: { type: Boolean, default: false }
    },
    data() {
        return {
            searchQuery: '',
        };
    },
    computed: {
        ...mapState('agency', ['emailConnections']),
        filteredEmailTemplates() {
            if (!this.searchQuery) {
                return this.emailConnections;
            }
            return this.emailConnections.filter(emailConnections => emailConnections.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
    },
}
</script>

<style lang="scss" scoped>
.email-connections-wrapper {
    max-height: 600px;
    overflow-y: auto;
}

.email-connections-search-field {
    margin: 8px 0;
}

.email-connections-panels {
    margin: 8px 0;
}

.email-connections-panel-text {
    padding: 0px 16px;
}

.email-connections-sub-section {
    margin: 24px auto;
    padding: 12px;
    border: 1px solid rgb(196, 196, 196);
    border-radius: 8px;
}


</style>